import { DefaultState } from 'store/types';
import { Filters } from 'store/types';

export const GET_EXTERNAL_CALLS_REQUEST = 'GET_EXTERNAL_CALLS_REQUEST';
export const GET_EXTERNAL_CALLS_SUCCESS = 'GET_EXTERNAL_CALLS_SUCCESS';
export const GET_EXTERNAL_CALLS_FAILURE = 'GET_EXTERNAL_CALLS_FAILURE';

export interface GetExternalCallsParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
}

export interface GetExternalCallsRow {
  timestamp: string;
  endpoint: string;
  status: string;
}

export interface GetExternalCallsData {
  rows: GetExternalCallsRow[];
  totalCount: number;
}

export type GetExternalCallsState = DefaultState & {
  contents?: GetExternalCallsData;
};

interface GetExternalCallsRequest {
  type: typeof GET_EXTERNAL_CALLS_REQUEST;
}

interface GetExternalCallsSuccess {
  type: typeof GET_EXTERNAL_CALLS_SUCCESS;
  contents: GetExternalCallsData;
}

interface GetExternalCallsFailure {
  type: typeof GET_EXTERNAL_CALLS_FAILURE;
}

export type GetExternalCallsActionTypes = GetExternalCallsRequest | GetExternalCallsSuccess | GetExternalCallsFailure;